export class SearchCriteriaConstant {
  daysToSearchAhead: number = 363;
  dafaultDepartureNumberOfDays: number = 1;
}
